import { Translation } from '@proget-shared/translate';

import { ConnectionType } from '../enum';
import { NetworkExtras } from '../type';

export class DeviceNetwork {
  public readonly connectionTypeLabel: Translation;

  constructor(
    public readonly connectionType: ConnectionType,
    public readonly ip: string,
    public readonly extras: NetworkExtras = {}
  ) {
    this.connectionTypeLabel = {
      key: connectionType
        ? `library.user_card.devices.list.connection_type.${connectionType}`
        : 'library.user_card.devices.list.no_information',
      params: this.extras,
    };
  }
}
